<div fxFlex="100" class="inputs" fxLayout="row wrap">
    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Charge Category Name'"
        [(ngModel)]="chargeCategoryObj.charge_category_name" [name]="'charge_category_name'" [minlength]="3"
        class="m1em" fxFlex="12em" fxLayout="column" [(errors)]="chargeCategoryObj.error.charge_category_name">
    </app-text-field>

    <!-- <app-edit-suggestion-field [isEditable]="true" [label]="'Charge Category Name*'" [displayField]="'charge_category_name'"
        [name]="'charge_category_name'" [(ngModel)]="chargeCategoryObj.charge_category_name" (onSelect)="editChargeGroupMaster($event)"
        [listUrl]="chargeMaster_url+'charge_group/?name=::search::'" [minlength]="3"
        [errors]="chargeCategoryObj.error.charge_category_name" class="m1em" fxFlex="12em" fxFlex.xs="10em"
        fxLayout="column">
    </app-edit-suggestion-field> -->

    <app-text-field [isMultiline]="true" [isEditable]="true" [label]="'Description'"
        [(ngModel)]="chargeCategoryObj.description" [name]="'description'" class="ai-fxs m1em " fxFlex="12em"
        fxFlex.xs="10em" fxLayout="column" [(errors)]="chargeCategoryObj.error.description">
    </app-text-field>

    <!-- <div class="ai-fxs m1em" fxFlex="26.4em" fxFlex.xs="100" fxLayout="column">
        <section>
            <mat-checkbox color="primary" [(ngModel)]="chargeCategoryObj.is_active" checked>Active</mat-checkbox>
        </section>
    </div> -->
    <div class="btnb">
        <button mat-stroked-button class="nxt" (click)="saveChargeCategory()">Save</button>
    </div>
</div>